// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterQuickLinks_root__c7ZWo","title":"FooterQuickLinks_title__39mdx","link":"FooterQuickLinks_link__3jvuE"};